export default __webpack_public_path__ + "static/media/Prisma_Cloud.336a6df9.svg";